import { Controller } from "@hotwired/stimulus"

declare const Plaid: {
  create(config: {
    token: string
    onSuccess: (publicToken: string, metadata: { institution?: { name: string; institution_id: string } }) => void
    onLoad: () => void
    onExit: (err: unknown, metadata: unknown) => void
    onEvent: (eventName: string, metadata: unknown) => void
  }): { open: () => void }
}

export default class extends Controller {
  static values = { link: String, linkField: String, linkType: String }
  static targets = ["form", "linkField", "name", "id"]

  declare readonly linkValue: string
  declare readonly linkFieldValue: string
  declare readonly linkTypeValue: string
  declare readonly formTarget: HTMLFormElement
  declare readonly linkFieldTarget: HTMLInputElement
  declare readonly nameTarget: HTMLInputElement
  declare readonly idTarget: HTMLInputElement

  connect() {
    const handler = Plaid.create({
      token: this.linkValue,
      onSuccess: (public_token, metadata) => {
        if (this.linkTypeValue === "new") {
          this.linkFieldTarget.value = public_token
          if (metadata.institution) {
            this.nameTarget.value = metadata.institution.name
            this.idTarget.value = metadata.institution.institution_id
          }
        }
        this.formTarget.submit()
      },
      onLoad: () => {},
      onExit: (err, metadata) => {
        this.formTarget.submit()
      },
      onEvent: (eventName, metadata) => {},
    })
    handler.open()
  }
}
